export default "__VITE_ASSET__BaFVw8Hh__"